import { useState, useEffect, useRef } from 'react'
import { Card, CardHeader, CardBody, CardFooter, Button, Form, FormGroup, Label, Input, FormFeedback, Alert } from 'reactstrap'
import { enterKeyHandler, passwordErrors } from '../../utils'
import useForm from '../CustomHooks/FormHook'

export default function ChangePasswordForm(props) {
  const { savePassword, saveError, cancelClicked, noHeader, cardMargin, noCancelButton, actionButtonText } = props
  console.log('ChangePasswordForm rendered ', props)

  // set the cursor to the "New Password" input field
  const newPasswordRef = useRef(null)
  useEffect(() => {
    newPasswordRef.current.focus()
  }, [])

  const { inputs, handleInputChange, handleKeyDown } = useForm({ newPassword: '', newPaswordConfirm: '' }, null, enterKeyHandler(submitClicked))
  const [newPasswordState, setNewPasswordState] = useState({ state: '', message: '' })
  const [newPasswordConfirmState, setNewPasswordConfirmState] = useState({ state: '', message: '' })
  const [error, setError] = useState('')

  function submitClicked() {
    console.log(`ChangePasswordForm.submitClicked newPassword: ${inputs.newPassword}`)
    if (!inputs.newPassword) {
      setNewPasswordState({ state: 'has-danger', message: 'New Password is required.' })
    } else {
      setNewPasswordState({ state: '', message: '' })
    }
    if (!inputs.newPasswordConfirm) {
      setNewPasswordConfirmState({ state: 'has-danger', message: 'Confirm New Password is required.' })
    } else {
      setNewPasswordConfirmState({ state: '', message: '' })
    }
    if (inputs.newPassword && inputs.newPasswordConfirm) {
      if (inputs.newPassword !== inputs.newPasswordConfirm) {
        setError('New Password and Confirm New Password must be the same.')
      } else {
        const errors = passwordErrors(inputs.newPassword)
        if (errors) {
          console.log(errors)
          const errorText = []
          let count = 0
          for (let err of errors) {
            errorText.push(<p key={count++}>{err}</p>)
          }
          setError(errorText)
        } else {
          setError('')
          savePassword(inputs.newPassword)
        }
      }
    }
  }

  const actionText = actionButtonText ? actionButtonText : 'Change Password'
  const cardHeader = noHeader ? '' : <CardHeader tag="h4">{actionText}</CardHeader>
  const margin = cardMargin ? cardMargin : '20px auto'
  const cancelButton = noCancelButton ? '' : <Button color="secondary" id="change-password-form-cancel-button" onClick={cancelClicked}>Cancel</Button>

  return (
    <Card style={{ maxWidth: '500px', margin: margin }}>
      {cardHeader}
      <CardBody>
        <div>
          <b>Password Requirements:</b>
          <ol>
            <li>Passwords must be at least 8 characters long.</li>
            <li>Passwords must satisfy at least 3 of the following:
              <ul>
                <li>At least one lowercase letter</li>
                <li>At least one uppercase letter</li>
                <li>At least one number</li>
                <li>At least one special character</li>
              </ul>
            </li>
          </ol>
        </div>
        <Alert className="change-password-form-alert" color="danger" isOpen={error || saveError ? true : false}>{error ? error : saveError}</Alert>
        <Form>
          <FormGroup>
            <Label for="newPassword">New Password</Label>
            <Input
              innerRef={newPasswordRef}
              type="password"
              id="newPassword"
              name="newPassword"
              invalid={newPasswordState.state === 'has-danger'}
              valid={newPasswordState.state === 'has-success'}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              data-cy="new-password"
            />
            <FormFeedback>{newPasswordState.message}</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="newPassword">Confirm New Password</Label>
            <Input
              type="password"
              id="newPasswordConfirm"
              name="newPasswordConfirm"
              invalid={newPasswordConfirmState.state === 'has-danger'}
              valid={newPasswordConfirmState.state === 'has-success'}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              data-cy="new-password-confirm"
            />
            <FormFeedback>{newPasswordConfirmState.message}</FormFeedback>
          </FormGroup>
        </Form>
      </CardBody>
      <CardFooter>
        {cancelButton}
        <Button color="primary" style={{ float: 'right' }} data-cy="change-password-button" onClick={submitClicked}>{actionText}</Button>
      </CardFooter>
    </Card>
  )
}